import Markdownit from 'markdown-it';
import markdownitAttr from 'markdown-it-attrs';
import markdownitBracketedSpans from 'markdown-it-bracketed-spans';
import markdownitSub from 'markdown-it-sub';
import markdownitSup from 'markdown-it-sup';
let md: Markdownit | null = null;

export function markdown(input: string, inline = false): string {
  if (md) {
    return inline ? md.renderInline(input) : md.render(input);
  }

  md = new Markdownit();
  md.use(markdownitAttr, {
    allowedAttributes: ['id', 'class'],
    leftDelimiter: '{',
    rightDelimiter: '}',
  });

  md.use(markdownitBracketedSpans);
  md.use(markdownitSub);
  md.use(markdownitSup);

  const linkOpenDefault = md.renderer.rules['link_open'];
  md.renderer.rules['link_open'] = (tokens, idx, options, env, self) => {
    const token = tokens[idx];
    if (!token) {
      return '';
    }

    const link = token.attrGet('href');

    // If local link (starts with /, no URI prefix)
    if (link?.startsWith('/')) {
      return `<a href='${link}' onClick='window.reactHistory("${link}"); return false;'>${token.content}</span>`;
    }

    token.attrSet('target', '_blank');

    return linkOpenDefault
      ? linkOpenDefault(tokens, idx, options, env, self)
      : self.renderToken(tokens, idx, options);
  };

  return markdown(input, inline);
}
